import * as React from 'react';

interface IProps {
    className?: string;
    style?: React.CSSProperties;
}

class VarannanVeckaLogo extends React.Component<IProps> {
    public static defaultProps = {
        className: undefined,
        style:undefined,
    };
    
    // tslint:disable:max-line-length
    public render(){
        return(
            <div className={this.props.className} >
                <img alt="" aria-hidden="true" style={this.props.style} src={require('../../images/vvlogo.svg')} />
            </div>
        );
    }
}  
export default VarannanVeckaLogo;



// WEBPACK FOOTER //
// ./src/components/svg/varannanvecka.tsx